import { TsDOM as q } from '@/scripts/core/TsDOM'
import { PasswordTennisBall } from '@/scripts/optional/password-tennis-ball'

q.safeDefineElement(PasswordTennisBall)
